export default "__VITE_ASSET__c5b60ff2__"